"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { TopBarConstants } from 'Constants/TopBarConstants';
import { SideDrawerConstants } from 'Constants/SideDrawerConstants';
import { LoginFormConstants } from "Constants/Login/LoginFormConstants";
import { user } from "Models/UserModel";
import { System } from "Constants/objects";
var defStore = {
  anchorMenuEl: null,
  drawerOpen: true,
  title: "",
  dynamicToolbar: null,
  dynamicToolbarContent: null
};

var _store = _objectSpread({}, defStore);

var CHANGE_EVENT = 'change';

var TopBarStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(TopBarStoreClass, _StoreClass);

  function TopBarStoreClass() {
    _classCallCheck(this, TopBarStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(TopBarStoreClass).apply(this, arguments));
  }

  _createClass(TopBarStoreClass, [{
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }]);

  return TopBarStoreClass;
}(StoreClass);

var TopBarStore = new TopBarStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case TopBarConstants.CLICK_USER_MENU:
      _store.anchorMenuEl = action.anchorMenuEl;
      TopBarStore.emit(CHANGE_EVENT);
      break;

    case TopBarConstants.CLOSE_USER_MENU:
      _store.anchorMenuEl = null;
      TopBarStore.emit(CHANGE_EVENT);
      break;

    case TopBarConstants.TOP_BAR_SET_TITLE:
      _store.title = action.title;
      TopBarStore.emit(CHANGE_EVENT);
      break;

    case TopBarConstants.TOP_BAR_SET_DYNAMIC_TOOLBAR:
      _store.dynamicToolbar = action.tb;
      break;

    case TopBarConstants.TOP_BAR_SET_DYN_TB_CONTENT:
      _store.dynamicToolbarContent = action.content;
      TopBarStore.emit(CHANGE_EVENT);
      break;

    case LoginFormConstants.DO_LOGOUT:
      _store.anchorMenuEl = null; //tmp

      TopBarStore.emit(CHANGE_EVENT);
      break;

    default:
      return true;
  }
});
export default TopBarStore;